/**
 * 智慧水务大屏（src/views/bNewScreen）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：Screen、BackGround、DataContainer、Header 及 supply/inspection/workorder/
 *          operation/main/meterReading 各模块图表卡片组件
 * 术语：智慧水务=Smart Water，营收=Revenue，抄表=Meter Reading，工单=Work Order，
 *       水质=Water Quality，巡检=Inspection，热线=Hotline，DMA=DMA，
 *       同比=YoY，环比=MoM，漏损率=Leakage Rate，远传表=Remote Meter
 */
export default {
  // ── 通用（复用全局词条，模块内自包含）──
  '确定': 'OK',
  '取消': 'Cancel',
  '关闭': 'Close',
  '详情': 'Details',
  '设置': 'Settings',
  '重试': 'Retry',
  '暂无数据': 'No Data',
  '数据加载中...': 'Loading data...',
  '标签': 'Label',
  // ── 顶部导航 / 标题 ──
  '智慧水务管理平台': 'Smart Water Management Platform',
  '供水分析': 'Water Supply Analysis',
  '运营分析': 'Operations Analysis',
  '抄表管理': 'Meter Reading Management',
  'DMA概览': 'DMA Overview',
  '工单管理': 'Work Order Management',
  '巡检管理': 'Inspection Management',
  '工艺控制': 'Process Control',
  // ── 供水分析 ──
  '供水监控': 'Water Supply Monitoring',
  '重点部位压力': 'Key Areas Pressure',
  '实时告警': 'Real-time Alarms',
  '水质指标分析': 'Water Quality Index Analysis',
  '水质合格率': 'Water Quality Compliance Rate',
  // ── DMA概览 ──
  '管网监测数据': 'Pipe Network Monitoring Data',
  '监测点': 'Monitoring Point',
  '压力(MPa)': 'Pressure (MPa)',
  '流量(m³/h)': 'Flow (m³/h)',
  '状态': 'Status',
  '漏损率排行': 'Leakage Rate Ranking',
  '近7日夜间最小流量': 'Minimum Night Flow (Last 7 Days)',
  '夜间最小流量趋势 (m³/h)': 'Minimum Night Flow Trend (m³/h)',
  '管线总长(km)': 'Total Pipeline Length (km)',
  '压力仪数': 'Pressure Gauges',
  '流量计': 'Flow Meter',
  '覆盖率': 'Coverage Rate',
  '东区泵站': 'East District Pump Station',
  '西水厂': 'West Water Plant',
  '南区管网': 'South District Pipe Network',
  '北区节点': 'North District Node',
  '中央主干': 'Central Trunk',
  '城东区域': 'East Urban Area',
  '城南区域': 'South Urban Area',
  '城西区域': 'West Urban Area',
  '城北区域': 'North Urban Area',
  '中央区域': 'Central Area',
  '周一': 'Mon',
  '周二': 'Tue',
  '周三': 'Wed',
  '周四': 'Thu',
  '周五': 'Fri',
  '周六': 'Sat',
  '周日': 'Sun',
  // ── 巡检管理 ──
  '巡检维保统计': 'Inspection & Maintenance Statistics',
  '区域巡检排名': 'Regional Inspection Ranking',
  '保养同期对比': 'Maintenance YoY Comparison',
  '本月任务': 'Tasks This Month',
  '巡检同期对比': 'Inspection YoY Comparison',
  '巡检保养完成率': 'Inspection & Maintenance Completion Rate',
  '异常状况监控': 'Abnormality Monitoring',
  '本月各区域排名': 'Area Ranking This Month',
  '最近30天异常情况': 'Abnormalities in the Last 30 Days',
  '故障设备排名': 'Faulty Device Ranking',
  '故障隐患趋势': 'Fault Hazard Trend',
  '故障设备分布': 'Faulty Device Distribution',
  '异常数量': 'Abnormalities',
  '异常趋势': 'Abnormality Trend',
  '故障分布': 'Fault Distribution',
  '累计巡检公里': 'Cumulative Inspection Kilometers',
  '累计保养次数': 'Cumulative Maintenance Times',
  '计划巡检': 'Planned Inspections',
  '实际巡检': 'Actual Inspections',
  '计划保养': 'Planned Maintenance',
  '实际保养': 'Actual Maintenance',
  '当日巡检任务数': 'Today\'s Inspection Tasks',
  '当日未巡检任务数': 'Today\'s Uninspected Tasks',
  '当日即将过期任务数': 'Tasks Expiring Today',
  '综合完结率(%)': 'Overall Completion Rate (%)',
  '去年': 'Last Year',
  '今年': 'This Year',
  '排名': 'Rank',
  '区域名称': 'Area Name',
  '完成情况': 'Completion',
  '暂无区域排名数据': 'No area ranking data',
  '月度': 'Monthly',
  '季度': 'Quarterly',
  '单位:个': 'Unit: Count',
  '单位:次': 'Unit: Times',
  '单位:%': 'Unit: %',
  '公里': 'km',
  '次': 'times',
  // ── 抄表管理 ──
  '物联网设备分析': 'IoT Device Analysis',
  '水表规格与在线统计': 'Meter Specs & Online Statistics',
  '小区远传表近7日抄见率': 'Community Remote Meter Reading Rate (Last 7 Days)',
  '抄表中心': 'Meter Reading Center',
  '厂家水表统计': 'Meter Manufacturer Statistics',
  '厂家水表在线率': 'Meter Online Rate by Manufacturer',
  '抄表指标': 'Meter Reading Indicators',
  '大用户水表': 'Large Customer Meters',
  '水表厂家情况汇总': 'Water Meter Manufacturer Summary',
  '水表在线率/故障率': 'Water Meter Online Rate / Fault Rate',
  '近三日上报率': '3-Day Reporting Rate',
  '近七日上报率': '7-Day Reporting Rate',
  '开阀': 'Open Valve',
  '关阀': 'Close Valve',
  '开阀数': 'Valves Opened',
  '关阀数': 'Valves Closed',
  '水表总数': 'Total Meters',
  '远传表数': 'Remote Meters',
  '非远传表数': 'Non-remote Meters',
  '总计/故障率': 'Total / Fault Rate',
  '个': 'pcs',
  '欠压': 'Undervoltage',
  '磁干扰': 'Magnetic Interference',
  '阀门故障': 'Valve Fault',
  '序号': 'No.',
  '小区名称': 'Community Name',
  '抄见时间': 'Meter Reading Time',
  '小区户数': 'Households',
  '抄见户数': 'Metered Households',
  '抄见率': 'Meter Reading Rate',
  '总户数': 'Total Households',
  '户数': 'Households',
  '抄见率(%)': 'Meter Reading Rate (%)',
  '厂家名称': 'Manufacturer Name',
  '远传/非远传': 'Remote/Non-remote',
  '传输方式': 'Transmission Type',
  '远传': 'Remote',
  '数量(个)': 'Quantity (pcs)',
  '故障率(%)': 'Fault Rate (%)',
  '数量': 'Quantity',
  '故障率': 'Fault Rate',
  // ── 运营分析 ──
  '用水量分析': 'Water Consumption Analysis',
  '用水类型分析': 'Water Use Type Analysis',
  '用户近半年用水统计': 'Customer Water Consumption (Last 6 Months)',
  '营收统计': 'Revenue Statistics',
  '年应收': 'Annual Receivable',
  '近一年月用水/缴费统计': 'Monthly Water Consumption/Payment (Last Year)',
  // ── 工单管理 ──
  '客户满意度': 'Customer Satisfaction',
  '工单业务趋势': 'Work Order Business Trends',
  '工单基本指标': 'Work Order Key Indicators',
  '实时工单数据': 'Real-time Work Order Data',
  '本月工单处理进度': 'Work Order Processing Progress This Month',
  '工单构成分析': 'Work Order Composition Analysis',
  '工单来源分析': 'Work Order Source Analysis',
  // ── 管网地图弹窗 ──
  '编码:': 'Code:',
  '名称:': 'Name:',
  '类型:': 'Type:',
  '高程:': 'Elevation:',
  '材质:': 'Material:',
  '管径:': 'Diameter:',
  '管长:': 'Length:'
}
